import { createI18n } from 'vue-i18n';
import en from '@/locales/en';
import fr from '@/locales/fr';

export type Locale = 'en' | 'fr';

export const SUPPORTED_LOCALES: ReadonlyArray<{
  code: Locale;
  label: string;
  dir: 'ltr' | 'rtl';
}> = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
];

const STORAGE_KEY = 'scala-watch:locale';

function pickInitialLocale(): Locale {
  if (typeof window === 'undefined') return 'en';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LOCALES.some((l) => l.code === stored)) {
    return stored as Locale;
  }
  const nav = window.navigator?.language?.slice(0, 2);
  if (nav && SUPPORTED_LOCALES.some((l) => l.code === nav)) {
    return nav as Locale;
  }
  return 'en';
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: pickInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, fr },
});

export function setLocale(code: Locale): void {
  i18n.global.locale.value = code;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, code);
    document.documentElement.lang = code;
    const meta = SUPPORTED_LOCALES.find((l) => l.code === code);
    document.documentElement.dir = meta?.dir ?? 'ltr';
  }
}
